module.exports = __webpack_public_path__ + "static/media/partly_cloudy_night.2502c2ce.svg";